import {
  PercentageField,
  PriceField,
  InputSelectControlField,
  TextInputField,
  RadioButtonGroupField,
  Box,
  Flex
} from '@sequencehq/core-components'
import { useLinearPriceForm } from './useLinearPriceForm'
import { LinearPriceType } from 'common/drawers/PricingEditor/domain'
import { PricingModelField } from '../common/PricingModelField'
import { Currency } from '@sequencehq/api'
import { UsageMetricParameterFields } from '../common/UsageMetrics/UsageMetricParameterFields'
import { ExternalLedgerForm } from '../common/ExternalLedgerForm/ExternalLedgerForm'
import { BillingFrequencyField } from '../common/BillingFrequencyField'
import { ProductSelectField } from '../common/ProductSelectField'
import { UsageMetricSelect } from 'UsageMetrics/index'

export const LinearPriceForm = () => {
  const { fieldsConfig, currency, formData } = useLinearPriceForm()

  return (
    <>
      <Flex direction="column" gap="16px">
        <ProductSelectField />

        <PricingModelField />

        <TextInputField
          label="Display name (appears on invoice)"
          data-testid="linear.name"
          value={fieldsConfig.name.value}
          onChange={e => fieldsConfig.name.onChange(e.target.value)}
          validationErrors={fieldsConfig.name.validationErrors}
          isDisabled={fieldsConfig.name.disabled}
          placeholder="Enter a display name"
        />

        <BillingFrequencyField
          data-testid="linear.billingFrequency"
          value={fieldsConfig.billingFrequency.value}
          options={fieldsConfig.billingFrequency.options}
          onChange={fieldsConfig.billingFrequency.onChange}
          validationErrors={fieldsConfig.billingFrequency.validationErrors}
          isDisabled={fieldsConfig.billingFrequency.disabled}
        />
        <UsageMetricSelect
          data-testid="linear.usageMetric"
          value={fieldsConfig.usageMetricId.value}
          onChange={fieldsConfig.usageMetricId.onChange}
          validationErrors={fieldsConfig.usageMetricId.validationErrors}
          isDisabled={fieldsConfig.usageMetricId.disabled}
        />
        <UsageMetricParameterFields
          fieldsConfig={fieldsConfig}
          usageMetricId={fieldsConfig.usageMetricId.value}
        ></UsageMetricParameterFields>
        <RadioButtonGroupField
          label="Type"
          data-testid="linear.linearPriceType"
          value={fieldsConfig.linearPriceType.value}
          options={fieldsConfig.linearPriceType.options}
          onChange={newValue =>
            fieldsConfig.linearPriceType.onChange(newValue as LinearPriceType)
          }
          validationErrors={fieldsConfig.linearPriceType.validationErrors}
          isDisabled={fieldsConfig.linearPriceType.disabled}
          fullWidth
        />
        {formData.linearPriceType === 'FIXED' && (
          <Flex alignItems="flex-start" gap="4px">
            <PriceField
              label="Price per unit"
              data-testid="linear.price"
              value={fieldsConfig.price.value}
              onChange={newValue => fieldsConfig.price.onChange(newValue)}
              validationErrors={fieldsConfig.price.validationErrors}
              currency={currency}
              isDisabled={fieldsConfig.price.disabled}
              borderTopRightRadius={0}
              borderBottomRightRadius={0}
              variant="v2"
            />
            {!fieldsConfig.currency.hidden && (
              <Box mt={6}>
                <InputSelectControlField
                  data-testid="linear.currency"
                  value={fieldsConfig.currency.value}
                  onChange={newCurrency =>
                    fieldsConfig.currency.onChange(newCurrency as Currency)
                  }
                  options={fieldsConfig.currency.options}
                  validationErrors={fieldsConfig.currency.validationErrors}
                  disabled={fieldsConfig.currency.disabled}
                  placeholder="Select currency"
                  width="150px"
                />
              </Box>
            )}
          </Flex>
        )}
        {fieldsConfig.linearPriceType.value === 'PERCENTAGE' && (
          <>
            {!fieldsConfig.currency.hidden && (
              <InputSelectControlField
                label="Currency"
                data-testid="linear.currency"
                value={fieldsConfig.currency.value}
                onChange={newCurrency =>
                  fieldsConfig.currency.onChange(newCurrency as Currency)
                }
                options={fieldsConfig.currency.options}
                validationErrors={fieldsConfig.currency.validationErrors}
                disabled={fieldsConfig.currency.disabled}
                placeholder="Select currency"
              />
            )}
            <PercentageField
              label="Percentage"
              data-testid="linear.percentage"
              value={fieldsConfig.percentage.value}
              onChange={newValue => fieldsConfig.percentage.onChange(newValue)}
              validationErrors={fieldsConfig.percentage.validationErrors}
              isDisabled={fieldsConfig.percentage.disabled}
              variant="v2"
            />
            <Flex flexDirection="row" gap="16px">
              <PriceField
                label="Floor fee (optional)"
                data-testid="linear.minPrice"
                value={fieldsConfig.minPrice.value}
                onChange={newValue => fieldsConfig.minPrice.onChange(newValue)}
                validationErrors={fieldsConfig.minPrice.validationErrors}
                currency={currency}
                isDisabled={fieldsConfig.minPrice.disabled}
                variant="v2"
                placeholder="0.00"
              />
              <PriceField
                label="Fee cap (optional)"
                data-testid="linear.maxPrice"
                value={fieldsConfig.maxPrice.value}
                onChange={newValue => fieldsConfig.maxPrice.onChange(newValue)}
                validationErrors={fieldsConfig.maxPrice.validationErrors}
                currency={currency}
                isDisabled={fieldsConfig.maxPrice.disabled}
                variant="v2"
                placeholder="0.00"
              />
            </Flex>
          </>
        )}

        <ExternalLedgerForm />
      </Flex>
    </>
  )
}
